//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function data() {
    return {
      userObj: {
        num: '000001',
        name: '张三',
        belongOrg: '深圳分行/零售金融事业部/私人银行中心',
        org: '深圳分行/零售金融事业部/私人银行中心',
        position: '分行副行长',
        tel: '13966666666',
        status: '正常',
        orgNum: '000001',
        coreOrgNum: '012324434'
      }
    };
  }
};